"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SimpleSettingDialog = void 0;
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CDialog = _interopRequireDefault(require("01_core/components/materials/CDialog"));
var _CMultiToggle = _interopRequireDefault(require("01_core/components/materials/CMultiToggle"));
var _CustomRouter = require("01_core/components/system/CustomRouter");
var _labelConsts = require("01_core/constants/labelConsts");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const DIALOG_MAX_WIDTH = 350;
const StyledDialogContent = (0, _styles.styled)(_DialogContent.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    padding: theme.spacing(2),
    width: '100%',
    maxWidth: DIALOG_MAX_WIDTH
  };
});
const StyledButton = (0, _styles.styled)(_CButton.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    padding: "".concat(theme.spacing(0.5), " ").concat(theme.spacing(1))
  };
});

/**
 * 設定ダイアログ
 * @prop {bool} open - 開閉フラグ
 * @prop {func} onChange - OKボタン押下時イベント
 * @prop {func} handleClose - 開閉フラグをオフにするイベント
 * @prop {string} value - 選択値
 * @prop {string} titleId - タイトルのid
 * @prop {Array} items - 選択肢
 * @prop {string} items.displayName - 表示名
 * @prop {string} items.value - 値
 *
 */
class SimpleSettingDialog extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "handleCancel", () => {
      this.setState({
        value: this.props.value
      });
      this.props.handleClose();
    });
    this.state = {
      value: this.props.value
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value
      });
    }
  }
  render() {
    const {
      intl,
      open,
      items,
      handleClose,
      onChange,
      titleId
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_CDialog.default, {
      open: open,
      maxWidth: false,
      "aria-labelledby": "form-dialog-title",
      handleClose: handleClose,
      title: intl.formatMessage({
        id: titleId
      }),
      PaperProps: {
        sx: {
          maxWidth: 350
        }
      }
    }, /*#__PURE__*/_react.default.createElement(StyledDialogContent, {
      sx: {
        marginTop: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_CMultiToggle.default, {
      options: items,
      selectedOption: this.state.value,
      onSelectOption: value => {
        this.setState({
          value
        });
      }
    })), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(StyledButton, {
      negative: true,
      onClick: this.handleCancel
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_CANCEL
    })), /*#__PURE__*/_react.default.createElement(StyledButton, {
      onClick: () => {
        onChange(this.state.value);
        handleClose();
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_OK
    }))));
  }
}
exports.SimpleSettingDialog = SimpleSettingDialog;
SimpleSettingDialog.propTypes = {
  open: _propTypes.default.bool.isRequired,
  onChange: _propTypes.default.func.isRequired,
  handleClose: _propTypes.default.func.isRequired,
  value: _propTypes.default.string.isRequired,
  titleId: _propTypes.default.string.isRequired,
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    displayName: _propTypes.default.string,
    value: _propTypes.default.string
  })).isRequired
};
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _CustomRouter.withRouter)(SimpleSettingDialog));